<div class="custom-header-container">
  <div class="grid w-full">
    <div class="col-6 sm:col-8 md:col-6 lg:col-4">
      <div class="w-full flex justify-content-between">
        <!-- Botão de navegação para mês anterior -->
        <button
          mat-icon-button
          class="n-botao-navegacao"
          (click)="previous()"
          [attr.aria-label]="'BARDO_AGENDA.MES_ANTERIOR' | translate"
        >
          <i class="pi pi-chevron-left"></i>
        </button>

        <!-- Rótulo de período (mês/ano ou intervalo), clicável para alternar visão -->
        <button
          mat-button
          class="custom-header-label-button"
          (click)="toggleYearView()"
          [attr.aria-label]="'BARDO_AGENDA.SELECIONAR_ANO' | translate"
        >
          {{ $periodLabel() }}
        </button>

        <!-- Botão de navegação para próximo mês -->
        <button
          mat-icon-button
          class="n-botao-navegacao"
          (click)="next()"
          [attr.aria-label]="'BARDO_AGENDA.PROXIMO_MES' | translate"
        >
          <i class="pi pi-chevron-right"></i>
        </button>
      </div>
    </div>
    <div
      class="col-6 sm:col-4 md:col-6 lg:col-8 flex justify-content-end gap-2"
    >
      <p-button
        [rounded]="true"
        icon="pi pi-calendar"
        [label]="'BARDO_AGENDA.HOJE' | translate"
        (onClick)="irParaHoje()"
      ></p-button>
      <p-button
        styleClass="p-button-outlined"
        [rounded]="true"
        data-tour="agenda-visao"
        [icon]="$iconVisualizarDiasConfirmados()"
        (onClick)="alternarVisualizacao()"
      ></p-button>
    </div>
  </div>
</div>
